export default function MissionSection() {
  const trustees = [
    "William Stafford",
    "Allistair Elliott",
    "David Owen",
    "Grace Huang",
  ];

  return (
    <section id="about" className="w-full bg-white py-16 scroll-mt-14">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-start gap-12">
          {/* Image side */}
          <div className="w-full lg:w-[420px] flex-shrink-0">
            <div className="rounded-lg overflow-hidden" style={{ height: "420px" }}>
              <img
                src="https://readdy.ai/api/search-image?query=professional%20orchestra%20musicians%20performing%20on%20stage%2C%20warm%20stage%20lighting%2C%20formal%20black%20attire%2C%20focused%20and%20dedicated%20performers%2C%20elegant%20concert%20hall%20setting%2C%20deep%20navy%20and%20warm%20gold%20tones%2C%20high%20quality%20photography%2C%20wide%20shot%20showing%20multiple%20musicians%20with%20instruments&width=840&height=840&seq=mpf-about-img-01&orientation=landscape"
                alt="Musicians' Pension Fund of Canada"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Text side */}
          <div className="flex-1">
            {/* Section label */}
            <div className="flex items-center gap-2 mb-4">
              <div className="w-6 h-0.5 bg-[#1a8fc1]"></div>
              <span className="text-[#1a8fc1] text-xs font-semibold tracking-widest uppercase">
                About
              </span>
            </div>

            <h2 className="text-2xl md:text-3xl font-bold text-[#0d1f4c] mb-5 leading-snug">
              About the Fund
            </h2>

            <p className="text-base text-gray-600 leading-relaxed mb-4">
              The Musicians&rsquo; Pension Fund of Canada administers pension benefits for
              eligible members and beneficiaries across Canada. The Fund is governed by a
              Board of Trustees and supported by the Fund Office.
            </p>

            {/* Mission statement */}
            <div className="bg-[#f3f6fa] border-l-[4px] border-[#1a8fc1] rounded-r-lg px-5 py-4 mb-6">
              <p className="text-sm text-gray-700 leading-relaxed italic">
                Our mission is to administer the Plan in a prudent manner to ensure its
                long-term viability in order to provide the best possible retirement
                benefits to the Fund&rsquo;s members and beneficiaries.
              </p>
            </div>

            {/* Fund Governance card */}
            <div className="bg-[#f8fafc] border border-gray-200 border-t-[3px] border-t-[#1a8fc1] rounded-lg p-6">
              <h3 className="text-base font-semibold text-[#0d1f4c] mb-4 flex items-center gap-2">
                <i className="ri-government-line text-[#1a8fc1]"></i>
                Fund Governance
              </h3>

              <div className="space-y-3">
                {/*  Executive Director */}
                <div className="flex items-baseline gap-2">
                  <span className="text-xs font-medium text-gray-500 tracking-wider w-[185px] flex-shrink-0 whitespace-nowrap">
                    Executive Director
                  </span>
                  <span className="text-sm font-semibold text-[#0d1f4c]">
                    Paul Versteeg-Lytwyn
                  </span>
                </div>

                {/* Chair */}
                <div className="flex items-baseline gap-2">
                  <span className="text-xs font-medium text-gray-500 tracking-wider w-[185px] flex-shrink-0 whitespace-nowrap">
                    Chair
                  </span>
                  <span className="text-sm font-semibold text-[#0d1f4c]">
                    Ellen Versteeg-Lytwyn
                  </span>
                </div>

                {/* Vice-Chair */}
                <div className="flex items-baseline gap-2">
                  <span className="text-xs font-medium text-gray-500 tracking-wider w-[185px] flex-shrink-0 whitespace-nowrap">
                    Vice-Chair
                  </span>
                  <span className="text-sm font-semibold text-[#0d1f4c]">
                    Bernard LeBlanc
                  </span>
                </div>

                {/* Trustees */}
                <div className="pt-2 border-t border-gray-200">
                  <div className="flex items-start gap-2">
                    <span className="text-xs font-medium text-gray-500 tracking-wider w-[185px] flex-shrink-0 pt-0.5 whitespace-nowrap">
                      Trustees
                    </span>
                    <div className="text-sm text-[#0d1f4c] space-y-1">
                      {trustees.map((name) => (
                        <div key={name} className="font-medium">
                          {name}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}